import { render } from "./app-confirm-dialog.vue?vue&type=template&id=20e3e45f&scoped=true"
import script from "./app-confirm-dialog.vue?vue&type=script&lang=js"
export * from "./app-confirm-dialog.vue?vue&type=script&lang=js"

import "./app-confirm-dialog.vue?vue&type=style&index=0&id=20e3e45f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e3e45f"]])

export default __exports__